/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CancelContextResponseCadence } from './cancelContextResponseCadence';
import type { CancelReasonOption } from './cancelReasonOption';

/**
 * Everything the cancel modal needs to render the right offer path.
 */
export interface CancelContextResponse {
  eligible: boolean;
  reason_ineligible?: string | null;
  plan_slug?: string | null;
  plan_name?: string | null;
  cadence?: CancelContextResponseCadence;
  period_end?: string | null;
  can_pause?: boolean;
  pause_months_options?: number[];
  discount_available?: boolean;
  discount_percent?: number | null;
  discount_redeemed?: boolean;
  reasons?: CancelReasonOption[];
}
